import React, { useState } from 'react';
import classnames from 'classnames/bind';

import { Category } from '@services';

import styles from './SubcategoriesNavbar.module.scss';
import { List, ListItem } from '@mui/material';
import { Button } from '@components';

const CN = 'subcategories-navbar';
const rootClassName = `${CN}--root`;
const containerClassName = `${rootClassName}--container`;
const subListClassName = `${containerClassName}--sublist`;
const paleSubListClassName = `${containerClassName}--pale-sublist`;
const subListHeaderClassName = `${subListClassName}--header`;
const cx = classnames.bind(styles);

interface SubcategoriesNavbarProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  category: Category | null;
  onCategoryClick: (categoryId: string) => Promise<boolean>;
}

export const SubcategoriesNavbar: React.FC<SubcategoriesNavbarProps> = ({
  category,
  isOpen,
  setIsOpen,
  onCategoryClick
}) => {
  const handleSubcategoryClick = (categoryKey: string): void => {
    onCategoryClick(categoryKey)
      .then(() => setIsOpen(false));
  };
  const [ hoveredSubCategoryd, setHoveredSubcategoryId ] = useState('');

  return (
    isOpen ? <div className={ cx(CN) } aria-label='subcategories-navbar'>
      <div
        className={ cx(rootClassName) }
      >
        <div className={ cx(containerClassName) }>
          { category?.children?.map(subcategory => (
            <List key={ subcategory.id } className={ cx(subListClassName, {
              [paleSubListClassName]: hoveredSubCategoryd && hoveredSubCategoryd !== subcategory.id
            }) }>
              <ListItem disableGutters disablePadding className={ cx(subListHeaderClassName) }>
                <Button
                  variant='text'
                  onClick={ (): void => handleSubcategoryClick(subcategory.key) }
                  onMouseEnter={ (): void => setHoveredSubcategoryId(subcategory.id) }
                  onMouseLeave={ (): void => setHoveredSubcategoryId('') }
                >
                  {subcategory.name}
                </Button>
              </ListItem>
              {subcategory.children?.map(l3subcategory => (
                <ListItem disableGutters disablePadding key={ l3subcategory.id }>
                  <Button
                    variant='text'
                    onClick={ (): void => handleSubcategoryClick(l3subcategory.key) }
                    onMouseEnter={ (): void => setHoveredSubcategoryId(subcategory.id) }
                    onMouseLeave={ (): void => setHoveredSubcategoryId('') }
                  >
                    {l3subcategory.name}
                  </Button>
                </ListItem>
              ))}
            </List>
          )) }
        </div>
      </div>
    </div> : null
  );
};
